import React from 'react';
import './greetings.css';

const Greetings = ({ greeting, farmName }) => (
  <div className="greeting-card">
    <p className="date">{new Date().toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</p>
    <h1>{greeting}, {farmName}!</h1>
  </div>
);

export default Greetings; 